module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (264).22fbbbb1.jpg";